import React from 'react';
import {
  TextField,
  SelectField,
} from '../../../ui/FormElement';

export default function ManagerFromMember({
  roles,
  enableFields,
  isAutomaticOnboarderForm,
  selectEnterprise, enterprises,
  onEnterpriseChange,
  isAdministratorForm,
  selectTeam,
  teams,
  selectMemberTeam,
  onMemberTeamChange,
  filteredMembers,
  setFieldValue,
  selectMemberRef,
  paymentMethods,
  isBillingManagerForm,
  selectPaymentMethod,
}) {
  return (
    <>
      <SelectField
        ref={selectEnterprise}
        name="enterprises"
        label={(
          <>
            <span>Enterprise</span>
            <abbr title="required">*</abbr>
          </>
        )}
        placeholder={
          enterprises === undefined
            ? 'Enterprise is loading ...'
            : 'Choose Enterprise...'
        }
        options={enterprises}
        onCustomonChange={(option) => onEnterpriseChange(option?.value)}
        menuPlacement="auto"
      />

      <SelectField
        ref={selectMemberTeam}
        name="member_team"
        label={(
          <span>Teams</span>
        )}
        placeholder="Choose Team..."
        options={teams}
        menuPlacement="auto"
        onCustomonChange={(option) => onMemberTeamChange(option === null ? null : option.value)}
      />

      <SelectField
        name="member"
        ref={selectMemberRef}
        label={(
          <>
            <span>Select Member</span>
            <abbr title="required">*</abbr>
          </>
      )}
        placeholder={
        enterprises === undefined
          ? 'Members are loading ...'
          : 'Choose Member...'
      }
        options={filteredMembers}
        menuPlacement="auto"
        onCustomonChange={(option) => {
          if (option) {
            setFieldValue('firstName', option.first_name);
            setFieldValue('lastName', option.last_name);
            setFieldValue('email', option.email);
          } else {
            setFieldValue('firstName', '');
            setFieldValue('lastName', '');
            setFieldValue('email', '');
          }
        }}
      />

      <TextField
        name="firstName"
        label={(
          <>
            <span>First Name</span>
            <abbr title="required">*</abbr>
          </>
        )}
        disabled
      />

      <TextField
        name="lastName"
        label={(
          <>
            <span>Last Name</span>
            <abbr title="required">*</abbr>
          </>
        )}
        disabled
      />

      <TextField
        name="email"
        type="email"
        label={(
          <>
            <span>Email</span>
            <abbr title="required">*</abbr>
          </>
        )}
        disabled
      />

      <SelectField
        name="role"
        label={(
          <>
            <span>Permission Level</span>
            <abbr title="required">*</abbr>
          </>
        )}
        placeholder="Choose Permission Level..."
        options={roles}
        onCustomonChange={(option) => enableFields(option)}
        menuPlacement="auto"
      />

      {isAutomaticOnboarderForm && (
        <TextField
          name="password"
          type="password"
          label={(
            <>
              <span>Password</span>
              <abbr title="required">*</abbr>
            </>
          )}
        />
      )}

      {!isAdministratorForm && (
        <SelectField
          ref={selectTeam}
          name="teams"
          label={(
            <>
              <span>Select Teams To Manage</span>
              <abbr title="required">*</abbr>
            </>
          )}
          placeholder="Choose Teams..."
          options={teams}
          isMulti
          menuPlacement="auto"
        />
      )}

      {isBillingManagerForm && (
      <SelectField
        ref={selectPaymentMethod}
        name="paymentMethod"
        label={(
          <span>Select Payment Method</span>
        )}
        placeholder="Choose Payment Method ..."
        options={paymentMethods
          ? paymentMethods.map((item) => ({ value: item.id, label: item.attributes.label }))
          : []}
        menuPlacement="auto"
      />
      )}

      <hr />

    </>
  );
}
